// Shared fetch() auth headers.
//
// Most of the app talks to the API through axios, which carries the bearer token on
// `axios.defaults`. The admin authoring surfaces still use native `fetch()`, which does
// not, so every one of those call sites has to attach the token itself. Several of them
// historically did not — which was invisible while the corresponding endpoints were
// unauthenticated, and became a 401 the moment they were locked down.
//
// Prefer axios for new code; use this when extending an existing `fetch()` caller.

const TOKEN_STORAGE_KEY = 'studyapp.com';

export function getAuthToken() {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch (_) {
    return null;
  }
}

/**
 * Headers for a JSON `fetch()` request, including the bearer token when present.
 * @param {object} [extra] - additional headers to merge in
 * @returns {object}
 */
export function authHeaders(extra = {}) {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

export default authHeaders;
